module.exports = {
  "Gattaran_MSGCenter__CDEL": "Instrucciones para la integración de mensajes",
  "Gattaran_Feedback__gRVu": "Se puede cargar hasta 1 archivo adjunto que no sea una imagen",
  "Gattaran_V2_wZWG_RFvr": "Cargar grupo objetivo",
  "Gattaran_Homepage__SgjR": "Lista de permisos",
  "Gattaran_Homepage__nRqe": "No hay historial de visitas",
  "Gattaran_Feedback__vYiO": "Selecciona",
  "common_yes": "Yes",
  "Gattaran_MSGCenter__fKLA": "Selecciona",
  "Gattaran_Feedback__bpPs": "Descripción del problema",
  "Gattaran_Feedback__QLll": "Módulo de funciones de Gattaran para buscar el lugar del problema",
  "Gattaran_V2_FXzs_ylzm": "Enviar para revisión",
  "Gattaran_V2_aQes_enLD": "Descripción",
  "Gattaran_MSGCenter__JYjL": "Ingresa",
  "Gattaran_Feedback__TtBS": "Enlace de la página donde ocurre el problema",
  "Gattaran_Feedback__zEDP": "Imágenes adjuntas (hasta 5 imágenes, de no más de 5MB cada una)",
  "Gattaran_Feedback__AOcA": "Remitente",
  "Gattaran_MSGCenter__rsFg": "Eliminar",
  "Gattaran_MSGCenter__jECw": "Enviar a través de la integración del negocio",
  "Gattaran_Feedback__auMY": "Ver",
  "Gattaran_MSGCenter__mzAm": "Notificaciones",
  "Gattaran_MSGCenter__esKt": "Ingresar palabra clave del título del mensaje",
  "Gattaran_Homepage__Ntsj": "Para obtener ayuda, comunícate con: {{pm_name}}",
  "Gattaran_MSGCenter__YFIH": "Núm de identificación",
  "Gattaran_Feedback__zikb": "Puedes consultar la lista \"Mis comentarios\" para ver el progreso del procesamiento de los mismos",
  "Gattaran_Homepage__qJVu": "Los enlaces a Mis solicitudes, Mis roles y Mi auditoría están aquí ahora",
  "Gattaran_V2_tuhT_AOTp": "Enviar periódicamente",
  "Gattaran_V2_qdkl_zhnr": "Máximo",
  "Gattaran_V2_elkQ_uPKA": "vez/veces",
  "Gattaran_20240401_cZwR_udOc": "Detalles de la encuesta",
  "Gattaran_V2_DECM_uvLB": "Nombre del botón de enlace (visualización predeterminada: {{default}})",
  "sailing.dilu.myfeedback": "Mis comentarios",
  "Gattaran_V2_crhT_oxkz": "En revisión",
  "Gattaran_Feedback__EAYk": "Identificación",
  "Gattaran_Homepage__IEfB": "Visitas recientes muestra las funciones que has visitado recientemente. Es una entrada de acceso rápido.",
  "soda-b-web-i18n---加载中": "Cargando...",
  "Gattaran_Homepage__HleZ": "Los siguientes roles tienen permisos para esta página:",
  "Gattaran_Feedback__MQam": "Grado de urgencia",
  "Gattaran_MSGCenter__GFMl": "Destinatarios objetivo",
  "Gattaran_Homepage__TQJz": "Esta página no está integrada en la nueva versión de Gattaran. Para acceder, haz clic en el siguiente botón.",
  "Gattaran_Homepage__HCuT": "Barra de navegación principal",
  "Gattaran_MSGCenter__buje": "Crear",
  "Gattaran_V2_uXMx_qica": "Descargar plantilla",
  "Gattaran_MSGCenter__Nbaz": "Fecha de inicio",
  "Gattaran_MSGCenter__yaaT": "Enlace del mensaje",
  "Gattaran_MSGCenter__SAQd": "Periodo de vigencia",
  "Gattaran_Feedback__IdvX": "Archivos adjuntos adicionales (Excel, PDF, Word; solo 1)",
  "Gattaran_Feedback__RCjf": "Dar nuevos comentarios",
  "Gattaran_MSGCenter__jnGI": "Configuración del contenido",
  "Gattaran_Feedback__dglB": "Descripción del problema",
  "Gattaran_Feedback__eNEw": "Región donde ocurre el problema",
  "Gattaran_Feedback__Xbej": "Alto",
  "FoodOpD_tools_Original_file_QXqs": "Descargar el archivo original",
  "FoodD_one_Try_again_qZka": "Reintentar",
  "Gattaran_MSGCenter__ZPZZ": "Palabra clave del título",
  "Gattaran_20240401_BAMn_cVoR": "Las preguntas de “Selección múltiple” deben contener al menos dos opciones",
  "Gattaran_V2_OAkm_oSIp": "El módulo correspondiente al producto final se mostrará en las opciones como remitente del mensaje en el Centro de mensajes de Gattaran.",
  "Gattaran_20240401_heKh_sVNg": "¿Es obligatoria?",
  "Gattaran_MSGCenter__HjTW": "Enviar a través del soporte del centro de mensajes",
  "Gattaran_MSGCenter__PvCm": "Hora de envío",
  "Gattaran_Feedback__fRJi": "Medio",
  "Gattaran_Feedback__dOJj": "Bajo",
  "Gattaran_MSGCenter__MWqV": "Buscar",
  "Gattaran_MSGCenter__imft": "Se puede cargar hasta una imagen",
  "Gattaran_Feedback__JuAw": "La conclusión sobre el procesamiento fue enviada con éxito, y el estado de los comentarios fue cambiado a \"Finalizado\"",
  "Gattaran_Auth_dmRq_HvpZ": "¿No puedes utilizar esta función?",
  "Gattaran_Homepage__Hjbo": "Contáctanos",
  "取消": "Cancel",
  "Gattaran_MSGCenter__qJkV": "Activo",
  "Gattaran_20240401_Dqdw_zVjj": "¿Confirmas que deseas iniciar esta encuesta?",
  "Gattaran_V2_wQRP_UYwo": "Revisor",
  "Gattaran_MSGCenter__iuwu": "Ingresar núm. de identificación",
  "Gattaran_20240401_ycgC_XryN": "Centro de encuestas",
  "Gattaran_Feedback__EhcV": "Información sobre los comentarios",
  "FoodOpC_gattaran_Enter_CWSB": "Ingresar texto aquí",
  "Gattaran_20240401_SptO_OiTm": "Se excedió el límite de caracteres",
  "Gattaran_20240401_dWRX_PBUn": "Tipo de encuesta",
  "Gattaran_MSGCenter__kLtS": "Fecha de finalización",
  "Gattaran_Homepage__ybCE": "En la página de inicio, puedes ver una descripción general del sistema de Gattaran",
  "Gattaran_Feedback__lQre": "Remitente",
  "Gattaran_MSGCenter__AjjW": "Enviar a la hora especificada",
  "Gattaran_V2_ayrB_ekxC": "Imagen de portada (relación de aspecto: 3:1, ancho sugerido: >800px)",
  "Gattaran_MSGCenter__vrnW": "Ver detalles",
  "Gattaran_Homepage__YscW": "Más",
  "Gattaran_Homepage__ssGO": "Permiso faltante: {{node_info}}",
  "Gattaran_Feedback__HTsy": "Enviar",
  "Gattaran_Feedback__urHD": "Bajo",
  "Gattaran_MSGCenter__KgwQ": "Lanzamiento",
  "Gattaran_MSGCenter__UnwR": "Crear",
  "Gattaran_Homepage__DMWj": "Manual de integración para RD",
  "Gattaran_Feedback__cLbb": "Medio",
  "Gattaran_V2_Tzot_kaOW": "Manual para PM/RD/PO",
  "Gattaran_MSGCenter__pUdp": "Detalles del mensaje",
  "Gattaran_V2_jXfh_Bzau": "Primero establece la selección de zona horaria",
  "Gattaran_20240401_bAxu_VxZT": "Participantes",
  "DiDi_Food_(C)_Customer_automatically_apply_Add_ZyML": "Agregar",
  "Gattaran_MSGCenter__jcAm": "Selecciona",
  "Gattaran_Feedback__qGnl": "Se enviaron los comentarios para la prueba de concepto (PoC) del producto {{pm_name}}",
  "Gattaran_20240401_cSnz_WMLD": "Selecciona varias",
  "Gattaran_20240401_iuEu_VEPo": "Pregunta de calificación (escala de 10 puntos)",
  "Gattaran_0411_MWuz_zfQj": "Ubicación de la encuesta",
  "Gattaran_MSGCenter__wEBm": "Sin mensajes",
  "Gattaran_Homepage__XHuN": "Una colección de ajustes básicos de las funciones de Gattaran, incluidas las tareas, la revisión, la configuración de los mensajes y los comentarios.",
  "Gattaran_Homepage__ktsW": "Confirmar",
  "Gattaran_Feedback__OHxt": "Comentarios",
  "Gattaran_Homepage__vkPG": "Haz clic en el enlace del grupo para unirte",
  "Gattaran_Homepage__yTjZ": "No tienes permiso para acceder a esta página",
  "Gattaran_MSGCenter__tcGJ": "Método de envío",
  "Gattaran_MSGCenter__tOPK": "Descripción del propósito",
  "Gattaran_MSGCenter__mwuC": "Título del mensaje",
  "Gattaran_MSGCenter__jtwt": "Creado el",
  "FoodOpB_Gattaran_Edit_dTpu": "Editar",
  "Gattaran_V2_uLPb_Hgku": "Grupo personalizado",
  "Gattaran_V2_pLhS_NyGm": "Mensajes enviados a través de la configuración del servidor de la base de datos",
  "Gattaran_20240401_Dror_RtHt": "Tipo de pregunta",
  "Gattaran_Feedback__LtzD": "Comentarios",
  "Gattaran_20240401_mhox_xExM": "Por favor, ingresa la descripción de la pregunta",
  "Gattaran_20240401_gZfx_mUCE": "Una vez que se haya iniciado esta encuesta, aparecerá de manera obligatoria como ventana emergente en la aplicación de BD y no podrá cerrarse. ¿Confirmas que deseas iniciar esta encuesta?",
  "Gattaran_lowcode_dTZL_JDSp": "Se abrió una nueva ventana. Por favor, visualízala en tu navegador.",
  "Gattaran_Feedback__KBWX": "Fecha y hora de actualización del estado",
  "soda-d-i18n---下载": "Descargar",
  "Gattaran_Feedback__HgXn": "Iniciar procesamiento",
  "Gattaran_Feedback__ZHEu": "Motivo del comentario",
  "Gattaran_Homepage__VxjE": "Barra de herramientas",
  "Gattaran_MSGCenter__NWqi": "Ver",
  "Gattaran_20240401_EyCp_urep": "Selecciona una",
  "Gattaran_Feedback__yvfR": "Cancelar",
  "Gattaran_Feedback__amKQ": "Alto",
  "Gattaran_MSGCenter__xZzf": "Periodo de vigencia",
  "Gattaran_Homepage__dzQv": "Aún no se asociaron permisos de rol a esta función",
  "Gattaran_20240401_BIfp_ZYiB": "Pregunta de calificación (escala de 5 puntos)",
  "Gattaran_20240401_gSOw_DugT": "Se agregaron {{research_num}} encuestas a la página de inicio de la aplicación de BD durante los últimos 30 días. Demasiadas encuestas podrían interrumpir el trabajo diario de los BD. ¿Confirmas que deseas iniciar esta encuesta?",
  "Gattaran_lowcode_axmA_FvoV": "No se pudo obtener la URL. Por favor, haz clic para intentar de nuevo o comunícate con el administrador de la plataforma.",
  "Gattaran_Homepage__YLig": "Intercambio de enlaces",
  "Gattaran_MSGCenter__PuUe": "Cargando...",
  "Gattaran_Feedback__EqVZ": "Grado de urgencia",
  "Gattaran_Homepage__upog": "Te damos la bienvenida a Gattaran",
  "Gattaran_Homepage__kLUb": "Yo",
  "Gattaran_MSGCenter__Kbqd": "Establecer una hora de envío especificada",
  "Gattaran_Feedback__dWQe": "Responsable de la tarea",
  "Gattaran_MSGCenter__GxXJ": "Establecer",
  "Gattaran_MSGCenter__cEqf": "Ingresa",
  "Gattaran_MSGCenter__BZkt": "Enviar registro",
  "Gattaran_MSGCenter__VINe": "Expandir",
  "Gattaran_Homepage__GVcy": "Descarga de recursos de diseño",
  "Gattaran_Feedback__ddlX": "Comentarios",
  "Gattaran_Homepage__FxHz": "Aceptar",
  "Gattaran_Homepage__QaKY": "Zona horaria: {{cityname}}",
  "FoodOpB_management_Maximum_quantity_JEJp": "Se alcanzó la cantidad máxima",
  "Gattaran_MSGCenter__rffG": "Restablecer",
  "Gattaran_Homepage__XxTT": "Guía de uso de Gattaran",
  "Gattaran_Feedback__SwBm": "Acciones",
  "Gattaran_Homepage__anfP": "Haz clic para ver la lista de las funciones correspondientes a cada módulo de funciones.",
  "Gattaran_Feedback__chUi": "Ingresa una descripción detallada del problema, como por ejemplo, cuándo, cómo hacer, qué, con qué frecuencia, etc.",
  "Gattaran_Feedback__cEaW": "Módulo",
  "Gattaran_Homepage__KEfd": "Haz clic en las opciones de la barra de navegación principal, como Tienda, Repartidor o Productos de datos, para cambiar entre los subsistemas correspondientes. El menú de navegación de la izquierda en el subsistema muestra todos los módulos de las funciones del subsistema para los que actualmente tienes permisos. Cada subsistema ofrece una página de resumen de las funciones, en la que puedes ver una lista completa de las funciones del subsistema, obtener una lista de funciones relacionadas y solicitar permisos rápidamente.",
  "FoodB_I_Exit_sfrY": "Cerrar sesión",
  "Gattaran_Homepage__AHIW": "Manual de diseño del producto",
  "Gattaran_Feedback__SHVh": "Responsable de la tarea",
  "Gattaran_V2_LuUu_Rpls": "Rechazada",
  "Gattaran_MSGCenter__myYJ": "Descargar plantilla",
  "sailing.dilu.SysBasicConfig": "Configuración del sistema",
  "Gattaran_MSGCenter__XIYn": "Configuración de mensajes",
  "Gattaran_Feedback__Govn": "Región donde ocurre el problema",
  "Gattaran_V2_NzFp_yjYY": "Ver detalles",
  "Gattaran_MSGCenter__FtSp": "Agregar",
  "soda-m-i18n---您当前的网络环境不太好，请更换至网络稳定的环境再次尝试": "Su entorno de red actual no es muy bueno, intente de nuevo para cambiar a un entorno de red estable",
  "Gattaran_Feedback__fnhs": "Conclusión sobre el procesamiento",
  "Gattaran_Homepage__OukI": "Usar versión anterior",
  "Gattaran_Feedback__ykZG": "Se pueden cargar hasta 5 imágenes",
  "Gattaran_Homepage__SbiO": "Los productos se reclasificaron según tu tipo de negocio. Familiarízate con el nuevo método de clasificación y descubre más funciones útiles.",
  "Gattaran_MSGCenter__kiOa": "Empresa",
  "Gattaran_MSGCenter__esUP": "¿Detener este mensaje?",
  "Gattaran_0416_aBBV_Ymcw": "Casilla de entrada con varias líneas",
  "Gattaran_V2_KeYD_zlnO": "La hora de envío debe ser igual o anterior a la hora de inicio del periodo de vigencia de la tarjeta de mensajes",
  "Gattaran_Feedback__mVws": "Cargar",
  "FoodOpC_Notifications_Time_zone_YaBE": "zona horaria",
  "Gattaran_MSGCenter__Xxgq": "Cancelar",
  "FoodOpB_copy_The_interval_zsXr": "El tiempo entre pedidos no puede ser mayor a {{day}} día(s).",
  "Gattaran_Homepage__Tchu": "Visitas recientes",
  "Gattaran_MSGCenter__pLZR": "Diario",
  "Gattaran_Homepage__XQjL": "Solicitar permisos",
  "Gattaran_MSGCenter__xOWq": "Contenido del mensaje",
  "Gattaran_V2_yYKm_eBiS": "Tarjeta de mensajes emergentes",
  "Gattaran_V2_lotK_apqj": "Hasta",
  "Gattaran_MSGCenter__HxEk": "Todo",
  "Gattaran_MSGCenter__ehbg": "Selección de zona horaria",
  "Gattaran_V2_omYw_wLSK": "Imágenes de contenido (hasta 4 imágenes)",
  "Gattaran_Homepage__PTEn": "Siguiente",
  "Gattaran_MSGCenter__eNOL": "Ingresa",
  "FoodC_remind_Unable_to_Wjlz": "No se puede cargar. Inténtalo de nuevo",
  "Gattaran_MSGCenter__iWDe": "Configuración básica",
  "Gattaran_MSGCenter__DUmv": "Enviar inmediatamente",
  "Gattaran_Feedback__SPGu": "Estado actual del procesamiento",
  "Gattaran_lowcode_dnHP_Gabp": "No se pudo cargar la página. Por favor, haz clic para intentar de nuevo o comunícate con el administrador de la plataforma.",
  "Gattaran_Homepage__lnWD": "Volver",
  "Gattaran_MSGCenter__yJJS": "Módulo del producto",
  "Gattaran_MSGCenter__bLAo": "Imagen (dimensiones sugeridas: 624px×312px)",
  "Gattaran_Homepage__uCVu": "Ver guía",
  "Gattaran_Homepage__lXkk": "Establecer país, zona horaria e idioma",
  "Gattaran_MSGCenter__vKEM": "Versión predeterminada",
  "Gattaran_MSGCenter__oHtl": "Marcar todo como leído",
  "Gattaran_MSGCenter__lbqY": "Acciones",
  "Gattaran_Homepage__bYLT": "Página de inicio",
  "Gattaran_MSGCenter__xBnV": "Emitido",
  "Gattaran_Homepage_soPn_KBFC": "Módulo común y plantillas de página",
  "Gattaran_MSGCenter__XgxF": "Grupo objetivo",
  "FoodOpB_Authority2_Role_List_OQWs": "Lista de roles",
  "Gattaran_Feedback__ktgU": "Este enlace de página no es válido",
  "Gattaran_Feedback__zzVL": "Enlace de la página donde ocurre el problema",
  "Gattaran_Feedback__adec": "Se ha iniciado el procesamiento de los comentarios y el estado de los mismos se ha cambiado a \"En proceso\".",
  "Gattaran_MSGCenter__wdfs": "Finalizado",
  "Gattaran_Feedback__xywA": "Ingresa",
  "Gattaran_20240401_SucJ_yXvM": "Opciones de la pregunta",
  "Gattaran_Homepage__qMzz": "o escanea el código QR para unirte al \"Grupo de comentarios en línea de Gattaran\" a través de D-Chat",
  "Gattaran_MSGCenter__ypXf": "Hora de envío",
  "Gattaran_MSGCenter__SGXp": "¿Eliminar este mensaje?",
  "Gattaran_MSGCenter__sQlj": "Creado por",
  "Gattaran_MSGCenter__wYPN": "Recepción de la solicitud",
  "Gattaran_MSGCenter__CUTJ": "{{version_num}} personalizada",
  "Gattaran_Feedback__pbpG": "Detalles sobre los comentarios",
  "Gattaran_Feedback__BoaN": "Motivo del comentario",
  "Gattaran_V2_fiBJ_wAfB": "Periodo de vigencia de la tarjeta de mensajes",
  "Gattaran_MSGCenter__qflV": "Selecciona",
  "Gattaran_Homepage__MtRG": "Ver permiso(s)",
  "sailing.dilu.newfeedback": "Comentarios",
  "Gattaran_0424_HooT_uHlF": "Cancelar",
  "Gattaran_MSGCenter__sRnc": "Seleccionar hora de creación",
  "Gattaran_Homepage__aeIE": "Haz clic para ver",
  "soda-m-i18n---查询到的数据有点小问题，请再试一次": "Los datos consultados tuvieron algún problema, inténtalo de nuevo más tarde",
  "Gattaran_Homepage__KisY": "Para acceder a esta función, solicita los permisos para el rol correspondiente de acuerdo a tu cargo.",
  "Gattaran_20240401_dTUg_cbfD": "Configuración del contenido de la encuesta",
  "Gattaran_20240401_EwyS_XNBx": "Título de la encuesta",
  "Gattaran_MSGCenter__WOKq": "Reducir",
  "Gattaran_Homepage__rxJe": "Cancelar",
  "Gattaran_MSGCenter__fKVx": "Título del mensaje",
  "Gattaran_MSGCenter__jVqk": "Recepción de la solicitud",
  "Gattaran_V2_HsHn_NQQR": "Frecuencia de visualización de la tarjeta de mensajes",
  "Gattaran_V2_ghDi_LLbp": "Grupo objetivo",
  "Gattaran_Feedback__UgYW": "Aceptar",
  "FoodB_statistics_Refresh_qDDP": "Actualizar",
  "Gattaran_MSGCenter__TIzW": "Tipo de idioma",
  "Gattaran_MSGCenter__Krud": "Estado",
  "Gattaran_MSGCenter__gzaW": "Selecciona",
  "Gattaran_V2_kzRk_KWRP": "Todos los grupos",
  "FoodB_2_Created_successfully_IqRa": "¡Creada correctamente!",
  "Gattaran_V2_Lyuv_BCOl": "Otra tarjeta de mensajes utiliza este periodo",
  "Gattaran_MSGCenter__tgFp": "Módulo del producto",
  "Gattaran_0424_aMnh_OeRE": "Confirmar",
  "FoodC_sales_Not_set_AJmE": "Más tarde",
  "Gattaran_20240401_vCtD_sEvO": "Crear nueva encuesta",
  "Gattaran_MSGCenter__chmB": "No hay más mensajes",
  "Gattaran_Homepage__KYtj": "Idioma",
  "Gattaran_Homepage__lRUO": "País",
  "Gattaran_0416_eOIG_voOz": "Agregar una pregunta",
  "Gattaran_Homepage__AmGl": "Permiso(s) existente(s)",
  "Gattaran_V2_XkEi_RPoU": "{{num}} vez/veces por día",
  "Gattaran_Homepage__BYnh": "Sin permiso",
  "Gattaran_Homepage__Fkve": "La barra de herramientas te permite configurar el país y el idioma, ver los mensajes y las notificaciones, y enviarnos tus comentarios.",
  "Gattaran_Feedback__QMDO": "Progreso del procesamiento",
  "Gattaran_Auth_fSHw_fDtt": "Solicita permiso ahora",
  "Gattaran_Feedback__WUQR": "Mis comentarios",
  "Gattaran_Feedback__NySC": "Comentarios enviados correctamente",
  "common_no": "No",
  "Gattaran_MSGCenter__jiXX": "Tipo de mensaje",
  "Gattaran_Homepage__pnNi": "Al hacer clic en este ícono, volverás a la página de inicio, donde podrás acceder rápidamente a la función “Visitas recientes”, ver una visión general del sistema Gattaran y solicitar permisos rápidamente.",
  "Gattaran_MSGCenter__SwjL": "Detener",
  "Gattaran_Auth_BQfS_LpZc": "Calificar",
  "Gattaran_MSGCenter__hpmD": "Tipo de mensaje",
  "FoodOpB_entrance_Learning_Centre_ENzd": "Centro de aprendizaje",
  "FoodB_modification_Modified_sTAw": "Edición completada",
  "Gattaran_mgt_Tips_NpAN": "Nota",
  "Gattaran_Homepage__oGEC": "Descripción general",
  "Gattaran_Feedback__GGDd": "Enviar conclusión",
  "Gattaran_Feedback__EeVZ": "Conclusión sobre el procesamiento",
  "Gattaran_20240401_hhVY_xurV": "Por favor, define al menos una pregunta",
  "Gattaran_Feedback__dGOG": "Cancelar",
  "Gattaran_20240401_FchZ_ipbt": "Configuración de la información básica",
  "Gattaran_MSGCenter__uZZb": "Imagen",
  "Gattaran_lowcode_xOev_XItQ": "No se pudo obtener el recurso de la página. Por favor, haz clic para intentar de nuevo o comunícate con el administrador de la plataforma.",
  "Gattaran_MSGCenter__RtfX": "Ingresar una descripción para la gestión de plantillas",
  "Gattaran_MSGCenter__oaHw": "Recuento de mensajes leídos",
  "Gattaran_0416_dvjl_GeNS": "Pregunta {{num}}",
  "Gattaran_notice_dpsU_cOCk": "Eliminada",
  "Gattaran_MSGCenter__WGno": "Selecciona"
}